import Text from "../../../../Components/Text";
import React, { useState, useEffect } from "react";
import Form from "../../../../Components/Form";
import NumberInput from "../../../../Components/Form/NumberInput";
import Discount from "../../../../APIController/Discount";

const DiscountForm = ({ afterAction }) => {
    const { createDiscount } = Discount()

    //Attributes
    const [percentage, setPercentage] = useState(null)

    const handleAddDiscount = async (discountDTO) => {
        await createDiscount(discountDTO)
        afterAction()
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        const discountDTO = {
            percentage: percentage
        }
        handleAddDiscount(discountDTO)
    }

    /* Form  */
    return (
        <Form onSubmitAction={handleSubmit} submitButtonText={"Rabatt erstellen"}>
            <Text type="maintitle" classNames={"flex text-center justify-center"}> {"Rabatt erstellen"}</Text>
            <div className="mb-4">
                <NumberInput attribute={percentage} id={"discountPercentage"} label={"Rabatt in %"} step="1" placeholder={"Rabatt in %"} action={(e) => setPercentage(e.target.value)} />
            </div>
        </Form>
    )
}
export default DiscountForm